import React from 'react';
import { SearchIcon as HeroSearchIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type SearchIconProps = Omit<IconProps, 'children'>;

export const SearchIcon: React.FC<SearchIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroSearchIcon />
        </Icon>
    );
};
